import React, { useEffect, useState } from 'react';
import { Loader2, CalendarDays } from 'lucide-react';
import { employeeApi, money, hrs, timeOf, dayLabel } from '../api';
import { EmployeeShell, goldCard, CircleIcon } from '../EmployeeShell';

export default function EmployeeHistory() {
  const [days, setDays] = useState(null);
  useEffect(() => { employeeApi.history().then((r) => setDays(r.data.days)).catch(() => setDays([])); }, []);

  return (
    <EmployeeShell>
      <div className="flex items-center gap-3 mb-5">
        <CircleIcon icon={CalendarDays} size="lg" />
        <div>
          <h1 className="text-white font-brand font-black text-2xl tracking-tight leading-none">Work History</h1>
          <p className="font-brand text-[10px] font-bold uppercase tracking-[0.18em] text-[#D4AF37] mt-1.5">Every shift, every dollar</p>
        </div>
      </div>
      {days === null ? <div className="flex justify-center py-16"><Loader2 className="animate-spin text-[#D4AF37]" size={26} /></div>
        : days.length === 0 ? (
          <div className={`${goldCard} p-10 text-center`} data-testid="history-empty">
            <CalendarDays size={32} className="text-gray-700 mx-auto mb-3" />
            <p className="text-gray-500 text-sm">No completed shifts yet. Clock in to start tracking!</p>
          </div>
        ) : (
          <div className="space-y-2" data-testid="history-list">
            {days.map((d) => (
              <div key={d.date} className={`${goldCard} px-4 py-3.5 flex items-center gap-3`}>
                <CircleIcon icon={CalendarDays} />
                <div className="flex-1 min-w-0">
                  <div className="text-white text-sm font-semibold">{dayLabel(d.date)}</div>
                  <div className="text-gray-500 text-xs truncate">{d.entries.map((e) => `${timeOf(e.clock_in_at)} – ${timeOf(e.clock_out_at)}`).join(' · ')}</div>
                </div>
                <div className="text-right shrink-0">
                  <div className="text-[#D4AF37] font-brand font-extrabold text-base tabular-nums">{money(d.total_earnings_cents)}</div>
                  <div className="text-gray-500 text-xs">{hrs(d.total_seconds)}</div>
                </div>
              </div>
            ))}
          </div>
        )}
    </EmployeeShell>
  );
}
